import {
  Avatar,
  Button,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useColorMode,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { IoMdMoon, IoMdSunny } from 'react-icons/io';
import PropTypes from 'prop-types';
import React from 'react';
import { toast } from 'react-toastify';
import axiosInstance from 'api/axiosInstance';
import apiUrls from 'api/apiUrls';

export default function HeaderLinks(props) {
  const { secondary } = props;
  const { colorMode, toggleColorMode } = useColorMode();
  const navigate = useNavigate();

  const navbarIcon = useColorModeValue('gray.800', 'yellow');
  let menuBg = useColorModeValue('white', 'navy.600');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );

  const handleLogout = async () => {
    try {
      await axiosInstance.post(apiUrls.logout);
      // localStorage.removeItem('authToken');
      // localStorage.removeItem('refreshToken');
      // localStorage.removeItem('UGXAuthorization');
      // localStorage.removeItem('ugxAccess');
      // localStorage.removeItem('ugxRefresh');
      localStorage.clear();

      toast.success('Logged out successfully');
      navigate('/auth/sign-in', { replace: true });
    } catch (error) {
      console.error('Logout failed:', error);
      toast.error('Logout failed. Try again.');
    }
  };

  return (
    <Flex
      w={{ sm: '100%', md: '100px' }}
      alignItems="center"
      justifyContent="space-between"
      flexDirection="row"
      // bg={menuBg}
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p="0.2rem"
      borderRadius="30px"
    >
      {/* <SidebarResponsive routes={routes} /> */}

      <Button
        variant="no-hover"
        bg="transparent"
        // ps="0.5rem"
        minW="unset"
        minH="unset"
        h="18px"
        w="max-content"
        border="5px"
        onClick={toggleColorMode}
      >
        <Icon
          me="10px"
          h="18px"
          w="18px"
          color={navbarIcon}
          as={colorMode === 'light' ? IoMdMoon : IoMdSunny}
        />
      </Button>

      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: 'pointer' }}
            name="Husk"
            bg="#434346ff"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              Configurator
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              onClick={handleLogout}
              bg="none"
              _hover={{ cursor: 'pointer' }}
              // _focus={{ bg: 'none' }}
              color={textColor}
              borderRadius="8px"
              px="14px"
            >
              <Text fontSize="sm">Log out</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
